import "../utils/KeyboardEventsUtil";
import { ResolutionHandler } from "../utils/ResolutionHandler";
import { CustomEvents } from '../utils/CustomEvents';
import { on, emit, off, one } from '../utils/EventsBus';
import { detect } from "detect-browser";
import "jquery-jcreate";
import { HideLoader } from '../utils/Loader';
import AnimateComponent from "../components/AnimateComponent";
import whatInput from "what-input";


export default class Controller {
  constructor() {
    this.loadedComponents = [];
    this.$customEvents = CustomEvents;
    this.$on = on;
    this.$emit = emit;
    this.$off = off;
    this.$one = one;
  }

  /**
   * Components that will be always initialized in every controller
   * @returns {string[]}
   * @constructor
   **/
  static get BASE_COMPONENTS() {
    return [
      'HeaderComponent',
      'CollapseComponent',
      'SearchLayerComponent',
      'CartLayerComponent',
      'CarouselComponent',
      'VideoBrightcoveComponent',
      'CommunicationPopupComponent',
      'NewsletterPopupComponent',
      'GoogleRecommendationEngineComponent',
      'RecommendationEngineComponent',
      'TrackingComponent',
      'DataShowComponent',
      'MiniCartComponent',
      'ShowPasswordComponent',
      'ModalComponent',
      'PersonalStylistComponent',
      'ChatComponent',
      'HeroComponent',
      'WishlistComponent',
      'CheckboxIconComponent',
      'TooltipComponent',
    ];
  }

  static get ALLOW_MULTIPLE_LOAD_COMPONENTS() {
    return [
      'O2OComponent',
      'CollapseComponent',
      'SizeSelectorComponent',
      'VideoBrightcoveComponent',
      'CustomSelectComponent',
      'ArticleTripleLaunchComponent',
      'ArticleGalleryComponent',
      'ArticleTwinScrollComponent',
      'ArticleProductComponent',
      'NotifyMeComponent',
      'HeroComponent',
      'CheckboxIconComponent',
      'TooltipComponent',
      'GoogleRecommendationEngineComponent',
    ];
  }

  setBrowserAttributes(obj) {
    return new Promise((resolve, reject) => {
      try {
        for (let key of Object.keys(obj)) {
          document.documentElement.setAttribute(
            `data-browser-${key}`,
            obj[key]
          );
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  /* * Adds a data-pixel-ratio attribute to the <html> element
   * with the current device pixel ratio (DPR) value.
   *
   * This is useful for responsive design and optimizing images
   * based on the device's pixel density. The attribute can be used in CSS or JS
   * to serve higher resolution images or adjust styles for high-DPI screens.
   */
  setPixelRatioAttribute() {
    const ratio = window && window.devicePixelRatio || 1;
    document.documentElement.setAttribute(`data-pixel-ratio`, ratio);
  }

    /**
   * Adds a data-keyboard-navigation attribute to the <html> element
   * when one of allowedKeysForKeyboardNavigation key is pressed, and sets it to false when any other key is pressed.
   *
   * This is useful for accessibility and focus management, allowing you to detect
   * when the user is navigating the page using the keyboard (specifically one of allowedKeysForKeyboardNavigation key)
   * versus other input methods. The attribute can be used in CSS or JS to style focus
   * outlines or trigger other behaviors based on keyboard navigation.
   */
  setKeyboardNavigationAttributes() {
    const allowedKeysForKeyboardNavigation = [
      'Tab',
      'Enter',
      'Space',
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
      'PageUp',
      'PageDown',
      'Escape',
      'Backspace',
      'Delete',
      'Shift',
      'Control',
    ];
    document.addEventListener('keydown', function (event) {
      if (allowedKeysForKeyboardNavigation.includes(event.key)) {
        document.documentElement.setAttribute('data-keyboard-navigation', 'true');
      } else {
        document.documentElement.setAttribute('data-keyboard-navigation', 'false');
      }
    });
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = "") {
    if (logStr != "") {
      let myName = this.constructor.name;
      console.debug(`[${myName}] ${logStr}`);
    }
  }

  /*
   *  Initialization logic of the page
   */
  init() {
    this.log("Initializing..");

    if (detect())
      this.setBrowserAttributes(detect()).then(res => {
        console.debug("Browser data saved");
      });

    if(whatInput) {
      this.setKeyboardNavigationAttributes();
    }

    this.setPixelRatioAttribute();

    ResolutionHandler();

    try {
      let componentsToRender = [];
      // Dynamic init of components related to a controller
      componentsToRender = [
        ...Controller.BASE_COMPONENTS,
        ...this.constructor.COMPONENTS
      ];
      this.log(`Rendering: ${componentsToRender}`);
      for (let component of componentsToRender) {
        this.instanceComponent(component);
      }
      // example of hiding loader, here so it works in every page, put it where needed
      HideLoader();
      // Common component for components' animations when they appear in view
      let animateComponent = new AnimateComponent();
      animateComponent.render();
    } catch (error) {
      console.error(
        "Failed to iterate over controller's components",
        error.stack
      );
    }
    //
    this.loadDynamicComponents();

    window && window.addEventListener('resize', this.setPixelRatioAttribute)

  }

  loadDynamicComponents() {
    // Dynamic init of components to be loaded
    let $this = this;
    // observer listener
    function listener(records) {
      let nodes = [];
      records.forEach(function (record) {
        var list = record.addedNodes;
        var i = list.length - 1;
        for ( ; i > -1; i-- ) {
          // if i find a new component
          if ( typeof list[i] == 'object' && list[i].nodeType == '1') {
            if (list[i].getAttribute('data-js-component') != null ) {
              nodes.push(list[i]);
            } else {
              let variabiledarinominare  = list[i].querySelectorAll("[data-js-component]");
              nodes = variabiledarinominare;
            }
          }
        }
      });
      // loop the nodes
      this.exit = false;
      nodes.forEach(node => {
        // taking the mutation
        let componentDiv = node;
        let componentToRender = componentDiv.getAttribute("data-js-component");
        if (componentToRender == null || componentToRender == "") return false;
        //
        if ($this.loadedComponents.indexOf([componentToRender]) === -1 && !this.exit) {
          $this.instanceComponent(componentToRender);
          // this.exit = true;
        } else if ( !this.exit ) {
          let newComp = new [componentToRender](event.currentTarget);
          // render new component
          newComp.render();
        }
      });
    }
    // define observer
    let observer = new MutationObserver(listener);
    // nodes to observe
    let targetNodes = document.querySelectorAll('.general-component');
    if ( typeof targetNodes != 'undefined' && targetNodes != null ) {
      // loop to observe each node
      targetNodes.forEach( target => {
        observer.observe(target, { childList: true, subtree: true });
      });
    }

    let sizeNode = document.querySelector('#editorial-content');
    if ( typeof sizeNode != 'undefined' && sizeNode != null ) {
      // loop to observe each node
        observer.observe(sizeNode, { childList: true, subtree: true });
    }
  }

  instanceComponent(ComponentName) {
    let selector = `[data-js-component="${ComponentName}"]`;
    if (document.querySelector(selector)) {
      let componentElements = document.querySelectorAll(selector);
      componentElements.forEach(element => {
        // check if contains the loaded class
        if (!element.classList.contains('component-loaded')) {
          // i add the class
          element.classList.add('component-loaded');
          this.importComponents(ComponentName)
            .then(({ default: ComponentName }) => {
              // i don't want to load multiple times a component, but with some exceptions
              // COMPONENTNAME must be added to component for that, thanks to yarn build and minification
              if (!this.loadedComponents.includes(ComponentName) || ( typeof ComponentName.prototype.COMPONENTNAME != 'undefined' && Controller.ALLOW_MULTIPLE_LOAD_COMPONENTS.includes(ComponentName.prototype.COMPONENTNAME) )  )  {
                let component = new ComponentName(element);
                component.render();
                this.loadedComponents.push(ComponentName);
              }
            })
            .catch(error => {
              console.error("Failed to load the component", error.stack);
            });
        }
      });
    }
  }


  /* --------------------------------------------------------------------- */
  /* this method import a module and returns the import promise            */
  /* with this method we centralize the dynamic import                     */
  /* --------------------------------------------------------------------- */
  importComponents(componentName) {
    if (componentName === "PdpGalleryComponent") {
      return import(
        /* webpackPreload: true */
        /* webpackChunkName: "component-PdpGalleryComponent" */
        "../components/PdpGalleryComponent"
      );
    }
    return import(
      /* webpackChunkName: "component-[request]" */
      `../components/${componentName}`
    );
  }
}
